module.exports = __webpack_public_path__ + "static/duration-9bbade8ee1751c7aff3681cd3266bf5b.svg";